import React, { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import "bootstrap-icons/font/bootstrap-icons.css";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../../Style.css";

const ForgotPassword = () => {
  //  // Fallback URL
  const url = process.env.REACT_APP_BACKEND_URL 

  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await axios.post(`${url}/auth/forgot-password`, {
        email,
      });
      // console.log(response)
      // toast.success(response.data.message || 'Check your email for reset instructions.');
      toast.success("Check your email for reset instructions.");
    } catch (err) {
      // toast.error(err.response?.data?.message || 'Failed to send reset link. Please try again.');
      toast.error("Failed to send reset link. Please try again.");
    } finally {
      setEmail("");
      setLoading(false);
    }
  };

  return (
    <div className="d-flex justify-content-center align-items-center vh-100 auth-bg">
      <div
        className="card p-4 shadow-lg w-100"
        style={{
          maxWidth: "400px",
          borderRadius: "15px",
          backgroundColor: "#fff",
          color: "#333",
        }}
      >
        <div className="text-center mb-4">
          <h3 className="mt-2" style={{ fontWeight: "600" }}>
            Forgot Password
          </h3>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label htmlFor="email" className="form-label">
              <i
                className="bi bi-envelope me-2"
                style={{ color: "#2a5298" }}
              ></i>
              Email
            </label>
            <input
              type="email"
              className="form-control shadow-sm"
              id="email"
              name="email"
              autoComplete="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              style={{ borderRadius: "10px" }}
            />
          </div>
          <div className="d-flex justify-content-center">
            <button
              type="submit"
              className="btn btn-primary btn-lg shadow-sm w-100"
              disabled={loading}
              aria-disabled={loading}
              style={{
                borderRadius: "25px",
                backgroundColor: "#2a5298",
                border: "none",
              }}
            >
              {loading ? "Sending..." : "Send Reset Link"}
            </button>
          </div>
          <div className="d-flex justify-content-center mt-3">
            <Link
              to="/"
              style={{
                fontSize: "0.9rem",
                fontWeight: "600",
                textDecoration: "none",
                color: "#2a5298",
              }}
            >
              Back to Login
            </Link>
          </div>
        </form>
      </div>
      <ToastContainer />
    </div>
  );
};

export default ForgotPassword;
